module.exports = __webpack_public_path__ + "img/detectors.ce7f6b33.png";